module.exports = {
    SVGPointToApiData(points){
        const tmp = points.reduce((m, p) => {
            return {
                x_max: Math.max(p.x,m.x_max),
                x_min: Math.min(p.x,m.x_min),
                y_max: Math.max(p.y,m.y_max),
                y_min: Math.min(p.y,m.y_min)
            }
        }, {x_max: -9999, x_min: 9999, y_max: -9999, y_min: 9999});

        const height = tmp.y_max - tmp.y_min;
        const width = tmp.x_max - tmp.x_min;
        const y_offset = tmp.y_min;
        const x_offset = tmp.x_min;

        const corrected_point = points.map(d => ({x:d.x - x_offset, y: d.y - y_offset}));

        return {
            width, height, x_offset, y_offset,
            top_left:     corrected_point[0],
            top_right:    corrected_point[1],
            bottom_left:  corrected_point[2],
            bottom_right: corrected_point[3],
        };
    },
    mousePointToSVGPoint(svg_el, target_el, x, y) {
        const p = svg_el.createSVGPoint();
        p.x = x;
        p.y = y;

        const CTM = target_el.getScreenCTM();

        return p.matrixTransform(CTM.inverse());
    },
    getCentroid(points, ratio = 1) {
        const point_names = [
            'top_left',
            'top_right',
            'bottom_right',
            'bottom_left',
        ];
        const arr = point_names.map(name => (Object.values(points[name]).map(n => n*ratio)) );
        const [x,y] = getCentroid2(arr);
        return {x,y};
    }

};

function getCentroid2 (arr) {
    let twoTimesSignedArea = 0;
    let cxTimes6SignedArea = 0;
    let cyTimes6SignedArea = 0;

    let length = arr.length;

    let x = function (i) { return arr[i % length][0] };
    let y = function (i) { return arr[i % length][1] };

    for ( let i = 0; i < arr.length; i++) {
        let twoSA = x(i)*y(i+1) - x(i+1)*y(i);
        twoTimesSignedArea += twoSA;
        cxTimes6SignedArea += (x(i) + x(i+1)) * twoSA;
        cyTimes6SignedArea += (y(i) + y(i+1)) * twoSA;
    }
    let sixSignedArea = 3 * twoTimesSignedArea;
    return [cxTimes6SignedArea / sixSignedArea, cyTimes6SignedArea / sixSignedArea];
}
